import { render, staticRenderFns } from "./ChangePracticeEmailModal.vue?vue&type=template&id=44bb58cc"
import script from "./ChangePracticeEmailModal.vue?vue&type=script&lang=js"
export * from "./ChangePracticeEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports